import {ElevateEnvironments} from 'src/features/admin-hosts/types'

export const elevateUrlEnvMap = {
    development: 'http://localhost:5173',
    staging: 'https://hostservices.frontend.k-stage.dev',
    production: 'https://elevate.translated.com'
} as const satisfies Record<ElevateEnvironments, string>
